import { createRouter, createWebHashHistory } from "vue-router";
import { isMobile } from "@/libs/tool";
import routes from "./config";
import routesM from "./config-m";

// const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const r = isMobile() ? routesM : routes;

const router = createRouter({
  history: createWebHashHistory(),
  routes: r,
});

router.beforeEach((to, from, next) => {
  if (to.meta) {
    document.body.style.backgroundImage = `url(${to.meta.bg})`;
  }

  if (to.name !== "Article") {
    document.title = "冒险岛次元站";
  }

  next();
});

export default router;
